<template>
  <div class="panel-container">
    <div
      v-if="propertyData?.lead_owner != null"
      class="panel desktop-panel sticky"
    >
      <div class="price-section">
        <div class="label mb-2">
          Prix de vente
        </div>

        <div class="value mb-2">
          {{ price }} €
        </div>
        <div
          class="value_m2"
        >
          {{ m2Price }} €/m²
        </div>
      </div>

      <HButton
        inverted
        block
        tag="link"
        :to="'/financement'"
        color="purple"
        class=" my-4"
      >
        Estimer ma capacité d'emprunt
      </HButton>

      <VDivider
        :thickness="1"
        color="#CECFD6"
        class="my-2"
        style="opacity: 1;"
      />

      <div v-if="!propertyData?.offer && !propertyData?.precontract && (!propertyData?.option || (propertyData.option && propertyData.off_market))">
        <HH5 class="text-center my-3">
          Visiter ce bien
        </HH5>

        <div
          v-if="(propertyData?.preselling === false && propertyData.key_id == null && propertyData.occupied === false && propertyData.deferred_possession === false) ||
            (propertyData?.preselling === true && propertyData.key_id == null && propertyData.occupied === false) ||
            (propertyData?.preselling === true && propertyData.key_id == null && propertyData.preselling_timeslots_configured === true) ||
            (propertyData?.deferred_possession === true && propertyData.preselling_timeslots_configured === true)"
          class="row mb-3"
        >
          <div class="col-12 col-xxl-6 mb-3 mb-xxl-0">
            <HButton
              block
              color="purple"
              :class="{videoActive: videoVisit === 0}"
              class="assisted-select-button"
              @click="togglePhysicalVisit()"
            >
              En personne
            </HButton>
          </div>
          <div class="col-12 col-xxl-6">
            <HButton
              block
              color="purple"
              :class="{videoActive: videoVisit === 1}"
              class="assisted-select-button"
              @click="toggleVideoVisit()"
            >
              En visio
            </HButton>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <HButton
              v-if="(propertyData?.preselling === false && propertyData.key_id != null && propertyData.occupied === false )||
                (propertyData?.preselling === true && propertyData.key_id != null && propertyData.occupied === false)"
              block
              tag="link"
              target="_blank"
              :to="visitUrl"
              color="purple"
            >
              Réserver une visite
            </HButton>
          </div>

          <div class="col-12">
            <HButton
              v-if="
                ((propertyData?.preselling === true &&
                  propertyData.key_id == null &&
                  propertyData.preselling_timeslots_configured === true) || (propertyData?.preselling_timeslots_configured === true && propertyData.deferred_possession === true)) &&
                  presellingVisitParams != null
              "
              block
              tag="link"
              target="_blank"
              :to="visitUrl + presellingVisitParams"
              color="purple"
            >
              Réserver une visite
            </HButton>
          </div>
          <div class="col-12">
            <HButton
              v-if="(propertyData?.preselling === true && propertyData.key_id == null && propertyData.preselling_timeslots_configured === false && propertyData.occupied === true) || (propertyData?.preselling_timeslots_configured === false && propertyData.deferred_possession === true)"
              block
              tag="link"
              target="_blank"
              :to="propertyData?.lead_owner?.calendly_phone_url"
              color="purple"
            >
              Appeler
            </HButton>
          </div>

          <div class="col-12">
            <HButton
              v-if="propertyData?.preselling_timeslots_configured === false && propertyData.key_id == null && propertyData.occupied === false && propertyData.deferred_possession === false && assistedVisitParams != null"
              block
              tag="link"
              target="_blank"
              :to="visitUrl + assistedVisitParams"
              color="purple"
            >
              Réserver une visite
            </HButton>
          </div>
        </div>

        <div class="d-flex align-center my-3">
          <VDivider
            :thickness="1"
            color="#CECFD6"
            class="my-3 mr-3"
            style="opacity: 1;"
          />
          <HH5>OU</HH5>
          <VDivider
            :thickness="1"
            color="#CECFD6"
            class="my-3 ml-3"
            style="opacity: 1;"
          />
        </div>

        <div
          class="make-offer"
        >
          <HButton
            inverted
            block
            tag="link"
            :to="'/acheter/annonces/offre/' + propertyDataId"
            color="purple"
          >
            Faire une offre d'achat
          </HButton>
        </div>

        <div
          v-if="propertyData?.off_market === true"
          class="make-option"
          style="margin-top: 10px;"
        >
          <HButton
            inverted
            tag="link"
            :to="'/acheter/annonces/option/' + propertyDataId"
            color="night-blue"
          >
            Faire une offre d'achat
          </HButton>
        </div>
      </div>

      <div class="lead-owner-section">
        <VAvatar size="x-large">
          <VImg
            :src="propertyData?.lead_owner?.avatar_url"
            cover
          />
        </VAvatar>
        <div class="ml-2">
          <div class="name">
            {{ propertyData?.lead_owner?.first_name }}
            {{ propertyData?.lead_owner?.last_name }}
          </div>
          <div class="role">
            {{ propertyData?.lead_owner?.job_title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  propertyData?: Record<string, any>,
}>()

const videoVisit = ref<number | null>(null)
const presellingVisitParams = ref<string | null>(null)
const assistedVisitParams = ref<string | null>(null)

const price = computed(() => {
  return numberWithSpace(Math.round(props.propertyData?.price?.value ?? 0))
})
const m2Price = computed(() => {
  return numberWithSpace(Math.round(props.propertyData?.price?.value / props.propertyData?.area?.value))
})

const visitUrl = computed(() => {
  return '/visite/' + (props.propertyData?.isReselling ? `r${props.propertyData?.id}` : props.propertyData?.id)
})

const propertyDataId = computed(() => {
  return props.propertyData?.id || ''
})

// onMounted(() => {
//   window.addEventListener('scroll', handleScroll)
//   handleScroll()
// })

// onUnmounted(() => {
//   window.removeEventListener('scroll', handleScroll)
// })

function togglePhysicalVisit () {
  videoVisit.value = 0
  presellingVisitParams.value = '?preselling=1'
  assistedVisitParams.value = '?assisted=1'
}

function toggleVideoVisit () {
  videoVisit.value = 1
  presellingVisitParams.value = '?preselling=1&video=1'
  assistedVisitParams.value = '?assisted=1&video=1'
}
</script>

<style lang="scss" scoped>
.assisted-select-button {
  opacity: 0.5;
}

.get-meeting {
  color: #fff;
  font-weight: bold;
  text-decoration: none;
}

.videoActive .get-meeting,
.assisted-select-button:hover .get-meeting,
.assisted-select-button:active:focus .get-meeting {
  opacity: 1;
}

.assisted-select-button:hover,
.assisted-select-button:active:focus,
.videoActive {
  opacity: 1;
}

.panel {
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
  background: #fff;
}

.panel-container {
  height: 100%;
}

@media (width >= 768px) {
  .panel.sticky {
    position: sticky;
    top: 100px;
  }

  .panel.absolute {
    position: absolute;
    right: 20px;
    bottom: 40px;
    width: 92%;
  }
}

.price-section {
  margin-top: 20px;

  .label {
    font-size: 16px;
    font-weight: normal;
    color: #1f1f1f;
  }

  .value {
    font-size: 41px;
    font-weight: bold;
    color: $purple;
  }

  .value_m2 {
    font-size: 18px;
    font-weight: bold;
    color: $purple;
  }
}

.address-section {
  margin-top: 20px;
  color: #1f1f1f;

  p {
    margin-bottom: 1px;
    font-size: 16px;
  }

  span {
    font-size: 12px;

    &.underlined {
      text-decoration: underline;
      font-size: 12px;
      font-weight: normal;
      cursor: pointer;
    }
  }
}

.meeting {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

@media (width <= 992px) {
  .meeting.sticky-mobile {
    position: fixed;
    bottom: 10px;
    left: 5%;
    width: 90%;
    z-index: 99999;
  }
}

@media (width <= 420px) {
  .get-meeting {
    font-size: 14px;
  }
}

.meeting button {
  background-color: $purple;
  width: 100%;
  padding: 10px;
  border-radius: 50px;
}

.meeting a {
  width:100%;
}

.make-offer button {
  border: 1px solid $purple;
  background: #fff;
  width: 100%;
  padding: 15px;
  border-radius: 50px;
  color: $purple;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;

  a {
    text-decoration:none;
    color: $purple;
  }
}

.make-option button {
  border: 1px solid #2E5AC7;
  background: #2E5AC7;
  width: 100%;
  padding: 15px;
  border-radius: 50px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;

  a{
    text-decoration:none;
    color: #FFF;

    &:hover button {
      color:#FFF !important;
    }
  }
}

.lead-owner-section {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-left: 0;
  color: #1f1f1f;
  padding-bottom: 20px;

  .name {
    font-weight: bold;
    font-size: 16px;
  }

  .role {
    font-size: 14px;
  }
}

.since-section {
  padding-left: 0;
  margin-top: 20px;
  color: #1f1f1f;
  font-size: 14px;
  padding-bottom: 20px;

  .label {
    font-weight: normal;
    text-align: left;
  }

  .value {
    text-align: right;
  }
}

.sticky-mobile-panel {
  display: none;
  position: fixed;
  background: #fff;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
}

@media (width <= 768px) {
  .meeting button {
    padding: 0;
  }

  .btn-visit {
    height: 44px;
  }

  .a-offer {
    width: 100%;
    height: 44px;
    margin-right: 7px;
  }

  .btn-offer {
    height: 100%;
    color: $purple;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    border: 0.5px solid $purple;
    text-align: center;
    padding: 14px;
  }

  .sticky-mobile-panel.visible {
    display: block;
  }

  .sticky-mobile-panel .row {
    margin-right: 15px;
    margin-left: 15px;
  }

  .title {
    font-weight: 900
  }

  .sticky-mobile-panel #title,
  .sticky-mobile-panel #subtitle {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: #1f1f1f;
    margin-top: 0;
    margin-bottom: 0;
  }

  .sticky-mobile-panel .property-title,
  .sticky-mobile-panel .price {
    padding: 0;
  }

  .sticky-mobile-panel .price .label {
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    color: #1f1f1f;
    text-align: right;
  }

  .sticky-mobile-panel .price .value {
    font-weight: bold;
    font-size: 18px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $purple;
    text-align: right;
  }

  .sticky-mobile-panel .price .value_m2 {
    font-weight: bold;
    font-size: 15px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $purple;
    text-align: right;
  }

  .meeting {
    margin-left: 15px;
    margin-right: 15px;
    padding-top: 8px;
  }

  #progress-bar {
    height: 2px;
    background: $purple;
  }
}
</style>
